import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill", "fill-opacity"]
const _hoisted_3 = ["fill", "fill-opacity"]

import { PropType } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationIcon18',
  props: {
    fill: {
      type: String,
      default: 'black',
    },
    fillOpacity: {
      type: String as PropType<'1' | '0.54'>,
      default: '0.54',
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M12.9052 7.09466C12.6127 6.80178 12.1372 6.80178 11.8447 7.09466L8.62491 10.314L7.28016 8.96966C6.98766 8.67678 6.51216 8.67678 6.21966 8.96966C5.92678 9.26253 5.92678 9.73728 6.21966 10.0302L8.09466 11.9052C8.24091 12.0518 8.43291 12.1249 8.62491 12.1249C8.81691 12.1249 9.00891 12.0518 9.15516 11.9052L12.9052 8.15516C13.198 7.86228 13.198 7.38753 12.9052 7.09466Z",
      fill: __props.fill,
      "fill-opacity": __props.fillOpacity
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M17.25 8.75C16.836 8.75 16.5 9.086 16.5 9.5C16.5 13.6355 13.1355 17 9 17C4.8645 17 1.5 13.6355 1.5 9.5C1.5 5.3645 4.8645 2 9 2C11.0134 2 12.9034 2.78675 14.3224 4.2155C14.6138 4.50987 15.0889 4.51137 15.3829 4.21925C15.6769 3.9275 15.6784 3.45275 15.3866 3.15875C13.6841 1.44425 11.4157 0.5 9 0.5C4.03725 0.5 0 4.53725 0 9.5C0 14.4628 4.03725 18.5 9 18.5C13.9628 18.5 18 14.4628 18 9.5C18 9.086 17.664 8.75 17.25 8.75Z",
      fill: __props.fill,
      "fill-opacity": __props.fillOpacity
    }, null, 8, _hoisted_3)
  ]))
}
}

})